import { render, staticRenderFns } from "./AnnualRoyaltyIncentive.vue?vue&type=template&id=4d89fa47&"
import script from "./AnnualRoyaltyIncentive.vue?vue&type=script&lang=js&"
export * from "./AnnualRoyaltyIncentive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports